import Button, { ButtonProps } from '@mui/material/Button';
import React from 'react';

const BareButton: React.FC<ButtonProps> = ({ children, ...rest }) => (
  <Button {...rest} variant="text" color="primary">
    {children}
  </Button>
);

export default BareButton;
